import useFiltersVariables from "components/Filters/useFiltersVariables";

import { FILTER_TYPE, INITIAL_SORT_OPTION, INITIAL_SORT_DIRECTION } from "./constants";

const useIntentProjectOperationFiltersVariables = () => {
  const { filterVariables, filterVariablesLoaded } = useFiltersVariables({
    filterType: FILTER_TYPE,
    initialSortDirection: INITIAL_SORT_DIRECTION,
    initialSortOption: INITIAL_SORT_OPTION,
  });

  return {
    fullTextSearch: filterVariables.searchInput,
    predicates: filterVariables.predicates,
    filterVariablesLoaded,
    sortOptionFields: filterVariables.sortOptionFields,
  };
};

export default useIntentProjectOperationFiltersVariables;
